import React from "react";
import { ActiveJourneyIcon, WrongIcon } from "../assets/icon";

interface Props {
  password: string;
}

const PasswordCriteria: React.FC<Props> = ({ password }) => {
  const checks = {
    length: password.length >= 8,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  const row = (passed: boolean, text: string) => (
    <div className="flex items-center gap-2 text-[12px] text-[#333D4D] dark:text-gray-300 font-semibold">
      {passed ? (
        <ActiveJourneyIcon  />
      ) : (
        <WrongIcon/>
      )}
      <span>
        {text}
      </span>
    </div>
  );

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6 mt-2">
      {row(checks.length, "At least 8 characters long")}
      {row(checks.uppercase, "One uppercase letter (A–Z)")}
      {row(checks.lowercase, "One lowercase letter (a–z)")}
      {row(checks.number, "One number (0–9)")}
      {row(checks.special, "One special character (!@#$%^&*)")}
    </div>
  );
};

export default PasswordCriteria;
